export default __webpack_public_path__ + "static/media/2.3150b853.png";